import { Box, Typography } from "@mui/material"

const ConstructionDisclaimer = () => {
    return (
        <Box sx={{ paddingTop: '16px', paddingBottom: '16px' }}>
            <Typography sx={{ fontStyle: 'italic' }}>
                {`Hi there! We're currently working on improving the Dashboard to make it more useful for you. For now, you’re seeing a previous version with details from the UI bug detection tool. Stay tuned — more updates are coming soon!`}
            </Typography>
            <Typography sx={{ fontStyle: 'italic' }}>
                {`Got ideas? We’d love to hear them! Just click "Product Roadmap" in the left menu to share your thoughts.`}
            </Typography>
        </Box>
    );
}

export default ConstructionDisclaimer;
